<template>
  <div class="main">
    <div class="left-bar">
      <sub-left-menu :menus="menus" :selectTrace="selectTrace"></sub-left-menu>
      <products-ranking topic="最新产品" :products="newProducts"></products-ranking>
    </div>
    <div class="sub-main">
      <breadcrumb :paths="selectTrace"></breadcrumb>
      <div class="product-detail">
        <div class="product-name">{{product.name}}</div>
        <!-- <div class="product-brief">{{product.info}}</div> -->
        <div class="product-content" v-html="product.content"></div>
        <div class="article-brief" v-if="product.file">附件：<a :href="'http://file.teamcorp.cn/wo_de/product/'+ product.file" :download="product.file">{{product.file}}</a></div> 
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/widgets/public/Breadcrumb'
import SubLeftMenu from '@/widgets/public/SubLeftMenu'
import ProductsRanking from '@/widgets/product/Ranking'
import service from '@/utils/service'
// import tools from '@/utils/base'

export default {
  components: { Breadcrumb, SubLeftMenu, ProductsRanking },
  data () {
    return {
      classifyTree: [],
      currentNode: [],
      product: {},
      newProducts: []
    }
  },
  created () {
    this.refreshProductInfo()
    this.loadNewProducts()
  },
  computed: {
    menus () {
      let menus = []
      for (var i in this.classifyTree) {
        let node = this.toMenuItem(this.classifyTree[i])
        if ('children' in this.classifyTree[i]) {
          let menuItem = []
          for (var j in this.classifyTree[i]['children']) {
            menuItem.push(this.toMenuItem(this.classifyTree[i]['children'][j]))
          }
          node['children'] = menuItem
        }
        menus.push(node)
      }
      return menus
    },
    selectTrace () {
      let selectTrace = []
      for (var i in this.currentNode) {
        selectTrace.push(this.toMenuItem(this.currentNode[i]))
      }
      return selectTrace
    }
  },
  methods: {
    refreshProductInfo () {
      this.productId = this.$route.params.id
      this.loadProduct()
    },
    refreshMenus () {
      this.loadPathTrace()
      this.loadMenu()
    },
    loadMenu () {
      let _this = this
      service.get('/product/classifyTree').then(function (response) {
        for (let i in response) {
          if (_this.hasClassify(response[i], _this.product.classifyId)) {
            _this.classifyTree = response[i].children
            return true
          }
        }
      })
    },
    hasClassify (tree, id) {
      if (parseInt(tree['nodeId']) === parseInt(id)) {
        return true
      }
      if ('children' in tree) {
        for (let i in tree['children']) {
          if (this.hasClassify(tree['children'][i], id)) {
            return true
          }
        }
      }
      return false
    },
    loadPathTrace () {
      if (this.product.classifyId > 0) {
        let _this = this
        service.get('/product/getTrace?nodeId=' + this.product.classifyId).then(function (response) {
          _this.currentNode = response
        })
      }
    },
    loadProduct () {
      let _this = this
      service.get('/product/detail?productId=' + this.productId).then(function (response) {
        _this.product = response
        _this.refreshMenus()
      })
    },
    loadNewProducts () {
      let _this = this
      service.get('/product/newProducts').then(function (response) {
        _this.newProducts = response
      })
    },
    toMenuItem (node) {
      return {'nodeId': node.nodeId, 'name': node.label, 'url': '/product?classifyId=' + node.nodeId}
    }
  },
  watch: {
    $route () {
      this.refreshProductInfo()
    }
  }
}
</script>

<style scoped>
.product-detail {
  padding: 30px;
  margin: 8px 0 0 0;
  background: #ffffff;
  min-height:1700px;
}
.product-name {
  font-size: 30px;
    color: #333333;
  text-align: center;
  margin: 15px 0 32px 0;
  line-height: 150%;
}
.product-brief {
  color: #888;
  padding:  0 15px 0 15px;
  font-family: "楷体";
}
p,span{
  font-size:15px;
  font-family: "宋体";
  line-height:27px;
  height:27px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/product/Detail.vue